import React, { useEffect, useState } from 'react';
import DelightsTable from './DelightsTable';
import { Dialog, DialogActions, DialogContent, Grid, TextField, useMediaQuery } from '@mui/material';
import { Box } from '@mui/material';
import TabsFilter from '../components/DelightsData/TabsFilter';
import SearchBar from '../components/DelightsData/SearchBar';
import { useGetAllDelightsRequestsQuery, useUpdateAdminRequestStatusMutation } from '../delightApiSlice';
import CustomDialogBox from '../../../common/CustomDialogBox';
import RequestDialog from '../components/DelightsData/RequestDialog';
import { DialogTitle } from '@mui/material';
import { Button } from '@mui/material';
import toast from 'react-hot-toast';
import SkeletonTable from '../../RnR/AdminRnR/SkeletonTable';
import { useTheme } from '@emotion/react';

const AdminDelights = () => {
  const { data, isLoading, isError, error } = useGetAllDelightsRequestsQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [searchText, setSearchText] = useState('');
  const [updateAdminRequestStatus] = useUpdateAdminRequestStatusMutation();
  const [rejectionReason, setRejectionReason] = useState('');
  const [openRejectionDialog, setOpenRejectionDialog] = useState(false);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const theme = useTheme();
  const handleShowDetails = (request) => {
    setSelectedRequest(request);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleUpdateStatus = async (requestId, type, adminRejectionReason) => {
    try {
      if ((type === 'reject' && adminRejectionReason.trim() !== '') || type === 'approve') {
        const response = await updateAdminRequestStatus({ requestId, adminRejectionReason }).unwrap();
        toast.success('Request status updated successfully!');
        setRejectionReason('')
        setOpenDialog(false);
        setSelectedRequest(null);
        setOpenRejectionDialog(false);
      } else {
        toast.error('Please Fill Rejection Reason');
      }
    } catch (error) {
      console.log(error, 'ERROR');
    }
  };

  const handleRejectionClick = () => {
    setOpenRejectionDialog(true);
  };

  if (isLoading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  const filteredData = data?.filter((request) => {
    const statusMatches =
      tabValue === 0 || request.adminStatus?.toLowerCase() === ['pending', 'approved', 'rejected'][tabValue - 1];
    const searchTextMatches =
      searchText === '' ||
      request.outingType?.toLowerCase().includes(searchText.toLowerCase()) ||
      request.numberOfMembers?.toString().includes(searchText) ||
      new Date(request.dateRequested).toLocaleDateString().includes(searchText) ||
      request.adminStatus?.toLowerCase().includes(searchText.toLowerCase()) ||
      request.requestedBy?.toLowerCase().includes(searchText.toLowerCase()) ||
      request.requestType?.toLowerCase().includes(searchText.toLowerCase());

    return statusMatches && searchTextMatches;
  });

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: '#EEF5FF',
        borderRadius: '10px',
        border: 1,
        borderColor: 'divider',
        p: 1,
        [theme.breakpoints.down('lg')]: {
          backgroundColor: 'transparent',
          p: 0,
          border: 0,
        },
      }}
    >
      <Grid
        item
        xs={8.6}
        sx={{
          backgroundColor: 'white',
          borderRadius: '10px',
          border: 1,
          borderColor: 'divider',
        }}
      >
        {isLoading ? (
          <SkeletonTable />
        ) : (
          <Box sx={{ borderRadius: '10px' }}>
            <TabsFilter tabValue={tabValue} setTabValue={setTabValue} data={data} />
            <SearchBar searchText={searchText} setSearchText={setSearchText} />
            <DelightsTable data={filteredData} handleShowDetails={handleShowDetails} />
          </Box>
        )}
      </Grid>
      {selectedRequest && (
        <CustomDialogBox
          fullScreen={'fullScreen'}
          height={'100%'}
          width="60%"
          open={openDialog}
          handleClose={handleCloseDialog}
          title="Details of Request"
          disabled={selectedRequest.adminStatus !== 'Pending'}
          content={<RequestDialog selectedRequest={selectedRequest} isAdmin={true} />}
          actions={[
            {
              label: 'Approve',
              onClick: () => handleUpdateStatus(selectedRequest?._id, 'approve', ''), // Approve action
            },
            {
              label: 'Reject',
              onClick: handleRejectionClick, // Open rejection dialog
            },
          ]}
        />
      )}
      <Dialog open={openRejectionDialog} onClose={() => setOpenRejectionDialog(false)}>
        <DialogTitle>Reject Request</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Rejection Reason"
            type="text"
            fullWidth
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
            required
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenRejectionDialog(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={() => handleUpdateStatus(selectedRequest?._id, 'reject', rejectionReason)} color="primary">
            Reject
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AdminDelights;
